import { gql } from "@apollo/client";

export const GET_CLIENT_HUB_ZONE_IMPORT_TASK_LISTING = gql`
    query GetClientHubZoneImportTaskListing(
        $filters: ClientHubZoneImportTaskFiltersTypeInput,
        $pageRequest: PageRequestTypeInput
    ) {
        getClientHubZoneImportTaskListing(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                taskNo
                channelId
                channelName
                hubId
                hubName
                activeTime
                filename
                submitterId
                status
                totalCount
                importedCount
                failedCount
                errorMessage
                createdAt
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface ClientHubZoneImportTaskType {
    id: number;
    taskNo: string;
    channelId: number;
    channelName?: string;
    hubId: number;
    hubName?: string;
    activeTime?: number | null;
    filename: string;
    submitterId: number;
    status: number;
    totalCount: number;
    importedCount: number;
    failedCount: number;
    errorMessage?: string;
    createdAt: number;
    updatedAt: number;
}

export interface ClientHubZoneImportTaskFiltersTypeInput {
    channelId?: number;
    hubId?: number;
    submitterId?: number;
    status?: number;
    createdAt?: {
        start?: string;
        end?: string;
    };
}

export interface PageRequestTypeInput {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
}

export interface ClientHubZoneImportTaskListingResponse {
    content: ClientHubZoneImportTaskType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface GetClientHubZoneImportTaskListingResponse {
    getClientHubZoneImportTaskListing: ClientHubZoneImportTaskListingResponse;
}

export interface GetClientHubZoneImportTaskListingVariables {
    filters?: ClientHubZoneImportTaskFiltersTypeInput;
    pageRequest?: PageRequestTypeInput;
}

